<template lang="pug">
  .container.search-results-container
    h1.search-results__header Suggested Products
    transition(name="fade")
      div(v-if="hasSearch")
        h2.search-results__subheader Showing {{ searchResults.length }} results for "{{ searchTerm }}"
        transition(name="fade")
          .search-results.collection-grid(v-if="searchResults.length > 0")
            .row.small-up-2.medium-up-4
              .column(v-for="item in searchResults")
                product-tile(:product="item")
          div.search-results__no-results(v-else)
            h2.search-results__subheader No products to show. Please enter a different search term.
            link-button.search-results__cta(
              label="Start Shopping"
              :href="getShopNowLink"
            )
</template>

<script>
  import Fuse from 'fuse.js'
  import { mapState } from 'vuex'
  import { allProductsHandle } from 'scripts/config/collections.js'

  import ProductTile from 'scripts/components/product/ProductTile.vue'
  import LinkButton from 'scripts/components/buttons/LinkButton.vue'

  export default {
    name: 'SearchResults',
    components: { ProductTile, LinkButton },
    props: {
      shopNowLink: String,
      search: String,
    },
    data () {
      return {
        searchTerm: this.search
      }
    },
    computed: {
      ...mapState({
        allCollections: state => state.collections.all
      }),
      collection () {
        return this.allCollections.find(collection => collection.handle === allProductsHandle)
      },
      searchResults () {
        let query = this.searchTerm.toLowerCase()

        let fuse = new Fuse(this.collection.products, {
          tokenize: true,
          keys: ['title', 'keywords']
        })

        return fuse.search(query)
      },
      hasSearch () {
        return this.searchTerm !== '' && Boolean(this.collection)
      },
      getShopNowLink() {
        if (this.shopNowLink) return this.shopNowLink;
        return '/collections/all';
      }
    },
    mounted () {
      const urlParams = new URLSearchParams(window.location.search);
      const pageNumber = urlParams.get('page');
      if (!this.collection) this.$store.dispatch('collections/addCollection', {
        handle: allProductsHandle,
        page: pageNumber,
      })
    }
  }
</script>

<style scoped lang="scss">
  .search-results-container {
    margin-bottom: 80px;
  }

  .search-results {
    margin-top: 87px;

    &__no-results {
      margin-top: 63px;
      text-align: center;
    }

    &__cta {
      margin-top: 25px;
    }

    &__header {
      font-size: rem(28);
      font-weight: bold;
      margin-bottom: 10px;
      text-align: center;
      color: $color-indigo;

      @include tablet-up {
        font-size: rem(44);
        margin-bottom: 24px;
      }
    }

    &__subheader {
      margin: 0;
      text-align: center;
      font-size: rem(18);
      font-weight: 400;
      font-family: $font-gibson;
      color: $text--main;
    }
  }
</style>
